// src/redux/actions/chatActions.ts
import { createAction } from '@reduxjs/toolkit';
interface Participant {
    participantId: string;
    participantType: string;
    displayName: string;
}
interface Message {
    body: {
      elementText: { text: string };
      elementType: string;
    };
    senderType?: string;
    senderParticipantType?: string;
    receivedAt?: string;
    lastUpdatedTimestamp?: string;
  }
// Action types
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const NEW_MESSAGE_RECEIVED = 'NEW_MESSAGE_RECEIVED';
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
export const SET_SOCKET_CONNECTIVITY = 'SET_SOCKET_CONNECTIVITY';
export const SET_SOCKET_INSTANCE = 'SET_SOCKET_INSTANCE';
export const ENGAGEMENT_CREATED = 'ENGAGEMENT_CREATED';

// Action creators
// Action creators with payload typing
export const setSocketConnectivity = createAction<any>('SET_SOCKET_CONNECTIVITY');
export const setSocketInstance = createAction<any>('SET_SOCKET_INSTANCE');
export const addParticipant = createAction<any>('ADD_PARTICIPANT');
export const removeParticipant = createAction<any>('REMOVE_PARTICIPANT');
export const newMessageReceived = createAction<any>('NEW_MESSAGE_RECEIVED');
export const engagementCreated = createAction<any>('ENGAGEMENT_CREATED');

